"use strict";
'use client';
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFin = void 0;
var react_1 = require("react");
var FinProvider_1 = require("../components/FinProvider");
function useFin() {
    var _a = (0, react_1.useContext)(FinProvider_1.FinContext), currentPath = _a.currentPath, nextPath = _a.nextPath, indicatorX = _a.indicatorX, contentMap = _a.contentMap, initialize = _a.initialize, initialized = _a.initialized;
    return { currentPath: currentPath, nextPath: nextPath, indicatorX: indicatorX, contentMap: contentMap, initialize: initialize, initialized: initialized };
}
exports.useFin = useFin;
//# sourceMappingURL=use-fin.js.map